const explicitUrl = import.meta.env.VITE_SUPABASE_REALTIME_URL;
const host = import.meta.env.VITE_SUPABASE_REALTIME_HOST ?? 'localhost';
const port = import.meta.env.VITE_SUPABASE_REALTIME_PORT ?? '4000';
const path = import.meta.env.VITE_SUPABASE_REALTIME_PATH ?? '/socket';
const protocol = import.meta.env.VITE_SUPABASE_REALTIME_PROTOCOL ?? (typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss' : 'ws');

const baseRealtimeUrl = explicitUrl ?? `${protocol}://${host}${port ? `:${port}` : ''}${path.startsWith('/') ? path : `/${path}`}`;

export const buildRealtimeUrl = (suffix = '', searchParams?: Record<string, string | number | boolean>) => {
  const normalizedSuffix = suffix ? `/${suffix.replace(/^\//, '')}` : '';
  const url = new URL(`${baseRealtimeUrl}${normalizedSuffix}`);

  if (searchParams) {
    Object.entries(searchParams).forEach(([key, value]) => {
      url.searchParams.set(key, String(value));
    });
  }

  return url.toString();
};

export const getRealtimeBaseUrl = () => baseRealtimeUrl;
